import React from 'react';

// Dynamic dashboard product images
import ImgLeadMagnet from '@/assets/images/dynamic-dashboard/add-product-lead-magnet.svg';
import ImgBox from '@/assets/images/dynamic-dashboard/box.svg';
import ImgDigitalDownload from '@/assets/images/dynamic-dashboard/add-product-dd.svg';
import ImgCalendar from '@/assets/images/dynamic-dashboard/add-product-calendar.svg';
import ImgMediaUrl from '@/assets/images/dynamic-dashboard/add-product-media-url.svg';
import ImgCommunity from '@/assets/images/dynamic-dashboard/add-product-community.svg';
import ImgCourse from '@/assets/images/dynamic-dashboard/add-product-course.svg';
import ImgMembership from '@/assets/images/dynamic-dashboard/add-product-membership.svg';
import ImgWebinar from '@/assets/images/dynamic-dashboard/add-product-webinar.svg';
import ImgAffiliateLink from '@/assets/images/dynamic-dashboard/add-product-affiliate-link.svg';

export interface ProductDefinition {
    id: string;
    title: string;
    subtitle: string;
    image: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export const LAUNCH_IN_MINUTES_PRODUCTS: ProductDefinition[] = [
    {
        id: 'collect-emails',
        title: 'Collect Emails',
        subtitle: 'Build your Email List, offer Free Products to your audience',
        image: ImgLeadMagnet,
    },
    {
        id: 'custom-product',
        title: 'Custom Product',
        subtitle: '"Ask Me Anything" requests, Audits/Analyses, Video Reviews',
        image: ImgBox,
    },
    {
        id: 'digital-product',
        title: 'Digital Product',
        subtitle: 'PDFs, Guides, Templates, Exclusive Content, eBooks, etc.',
        image: ImgDigitalDownload,
    },
    {
        id: 'coaching-call',
        title: 'Coaching Call',
        subtitle: 'Book Discovery Calls, Paid Coaching',
        image: ImgCalendar,
    },
    {
        id: 'external-links',
        title: 'External Links',
        subtitle: 'Offers, resources, or pages',
        image: ImgMediaUrl,
    },
];

export const MORE_PRODUCTS: ProductDefinition[] = [
    {
        id: 'community',
        title: 'Community',
        subtitle: 'Host a free or paid community',
        image: ImgCommunity,
    },
    {
        id: 'ecourse',
        title: 'eCourse',
        subtitle: 'Create, Host, and Sell your Course within Stan',
        image: ImgCourse,
    },
    {
        id: 'recurring-membership',
        title: 'Recurring Membership',
        subtitle: 'Charge Recurring Subscriptions',
        image: ImgMembership,
    },
    {
        id: 'webinar',
        title: 'Webinar',
        subtitle: 'Host exclusive coaching sessions or online events with multiple customers',
        image: ImgWebinar,
    },
    {
        id: 'stan-affiliate-link',
        title: 'Stan Affiliate Link',
        subtitle: 'Refer a friend and receive 20% of their Stan Subscription fee each month!',
        image: ImgAffiliateLink,
    },
];
